import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Row, Col, Table, Button } from "react-bootstrap";
import { GetCurrentUserName } from "../../utils/permissionChecker";
import { calculateTax } from "../../utils/tax_calculator";
import { toast } from "react-toastify";
const SalaryPreview = ({ closeModal, employeeData }) => {
  const { t } = useTranslation();
  const loggedInUser = GetCurrentUserName();

  if (!employeeData || !Array.isArray(employeeData)) {
    return <div>No employee data available</div>;
  }
  const month = 11;
  const year = 2024;
  const branch_id = "";
  const restructuredData = employeeData.map((employee) => {
    const total_deductions_fixed_amount =
      employee.total_deductions_fixed_amount || 0;
    const total_deductions_percentage =
      employee.total_deductions_percentage || 0;
    const salary = employee.employee_details[0]?.salary || 0;
    const total_benefit_fixed_amount = employee.total_benefit_fixed_amount || 0;
    const penality = employee.penality ? parseFloat(employee.penality) : 0;
    const penality_reason = employee.reason;
    const total_deduction =
      penality +
      total_deductions_fixed_amount +
      (total_deductions_percentage * salary) / 100;
    const totla_benefit_in_percentage = employee.total_benefit_percentage || 0;
    const total_benefit_in_amount = employee.total_benefit_fixed_amount || 0;
    const total_benefit =
      total_benefit_in_amount + (totla_benefit_in_percentage * salary) / 100;
    const taxable_benefit =
      employee.total_taxable_benefit_amount +
      (employee.total_taxable_benefit_percentag * salary) / 100;
    const none_Taxable_benefit =
      employee.total_nonTaxable_benefit_amount +
      (employee.total_nonTaxable_benefit_percentage * salary) / 100;
    const salary_tax = calculateTax(salary);
    const benefit_tax = calculateTax(taxable_benefit);
    const total_tax = salary_tax + benefit_tax;
    const pension = parseFloat((salary * 0.07).toFixed(2));
    const total_pension = parseFloat((salary * 0.18).toFixed(2));
    const net_payment =
      salary + total_benefit - (total_deduction + total_tax + pension);
    return {
      emp_id: employee.id,
      full_name: `${employee.first_name} ${employee.father_name}`,
      phone: employee.phone,
      sex: employee.sex,
      tin_number: employee.tin_number,
      department: employee.department,
      salary: pension,
      total_pension,
      deduction_in_percent: (total_deductions_percentage * salary) / 100,
      deduction_in_amount: total_deductions_fixed_amount,
      benefit_in_percent: (employee.total_benefit_percentage * salary) / 100,
      benefit_in_amount: total_benefit_fixed_amount,
      total_deduction: total_deduction,
      total_benefit: total_benefit,
      taxable_benefit: taxable_benefit,
      none_Taxable_benefit: none_Taxable_benefit,
      salary_tax,
      benefit_tax,
      total_tax,
      net_payment,
      penality,
      penality_reason,
      month,
      year,
      branch_id,
      status: 1,
      current_status: "prepared",
      prepared_by: loggedInUser,
      updated_by: loggedInUser,
    };
  });

  const checkData = restructuredData.filter(
    (employee) => employee.net_payment < 0
  );

  const previewPayroll = (e) => {
    e.preventDefault();
    console.log(restructuredData);
  };
  return (
    <Container fluid>
      <Row>
        <Col lg="12">
          <Row>
            <Col lg="12">
              <Table>
                <thead>
                  <tr>
                    <th>{t("name")}</th>
                    <th>{t("salary")}</th>
                    <th>{t("benefit")}</th>
                    <th>{t("deduction")}</th>
                    <th>{t("tax")}</th>
                    <th>{t("pension")}</th>
                    <th>{t("net_pay")}</th>
                  </tr>
                </thead>
                <tbody>
                  {restructuredData.map((employee) => (
                    <tr key={employee.id}>
                      <td>
                        <div className="data-content">
                          <span className="font-weight-bold">
                            {employee.full_name}
                          </span>
                          <p className="m-0 text-secondary small">
                            Phone: {employee.phone}
                          </p>
                          <p className="m-0 text-secondary small">
                            Department: {employee.department}
                          </p>
                        </div>
                      </td>
                      <td>{employee.salary}</td>
                      <td>
                        <div className="data-content">
                          <span className="font-weight-bold">
                            {employee.total_benefit}
                          </span>
                          <p className="m-0 text-secondary small">
                            Taxable: {employee.taxable_benefit}
                          </p>
                          <p className="m-0 text-secondary small">
                            Non Taxable: {employee.none_Taxable_benefit}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div className="data-content">
                          <span className="font-weight-bold">
                            {employee.total_deduction}
                          </span>
                          <p className="m-0 text-secondary small">
                            Deduction:{" "}
                            {employee.total_deduction - employee.penality}
                          </p>
                          <p className="m-0 text-secondary small">
                            Penality: {employee.penality}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div className="data-content">
                          <span className="font-weight-bold">
                            {employee.total_tax}
                          </span>
                          <p className="m-0 text-secondary small">
                            Income: {employee.income_tax}
                          </p>
                          <p className="m-0 text-secondary small">
                            Benefit: {employee.benefit_tax}
                          </p>
                        </div>
                      </td>
                      <td>{employee.pension}</td>
                      <td>{employee.net_payment}</td>
                    </tr>
                  ))}
                </tbody>
                {checkData.length !== 0 ? (
                  <p className="text-danger">
                    {checkData.length} employee data is not correct please
                    review again
                  </p>
                ) : (
                  <div className=" position-relative d-flex align-items-center justify-content-between">
                    <Button
                      variant="btn btn-info btn-sm m-2"
                      onClick={(event) => previewPayroll(event)}
                    >
                      {t("submit_payroll")}
                    </Button>
                  </div>
                )}
              </Table>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default SalaryPreview;
